export var MappingSource;
(function (MappingSource) {
    MappingSource[MappingSource["Task"] = 0] = "Task";
    MappingSource[MappingSource["PriceListItemLink"] = 1] = "PriceListItemLink";
    MappingSource[MappingSource["CategoryLink"] = 2] = "CategoryLink";
    MappingSource[MappingSource["Mapping"] = 3] = "Mapping";
})(MappingSource || (MappingSource = {}));
